export * from "./MediaLibraryTrackEvents";
export * from "./IdeaPlannerTrackEvents";
export * from "./IntegrationsTrackEvents";

// GENERAL
export const HEADER_MENU_ADD_USER_CLICK = "clicked-user-top";
export const HEADER_ADD_USER_CLICK = "add-user-button-top";
export const HEADER_MENU_ADD_ACCOUNT_CLICK = "clicked-account-top";
export const HEADER_ADD_ACCOUNT_CLICK = "add-account-button-top";
export const HEADER_SUPPORT_CLICK = "contact-support-button-top";

// SERVICE STATUS — live status.skedsocial.com indicator in the dashboard.
// Impression fires once per incident/maintenance shown per session (banner or
// header badge); click fires on any click-through to the status page.
export const SERVICE_STATUS_IMPRESSION = "service-status-impression";
export const SERVICE_STATUS_CLICK = "service-status-click";

// ADD ACCOUNT — per-platform clicks on the connect dialog cards (incl. the
// notification-style cards: IG personal, Threads notification, Snapchat,
// Other). Names follow the legacy `accounts-clicked-add-*` convention so
// existing Amplitude / HubSpot dashboards keep working.
export const ADD_ACCOUNT_CLICKED_INSTAGRAM = "accounts-clicked-add-instagram";
export const ADD_ACCOUNT_CLICKED_INSTAGRAM_PERSONAL =
  "accounts-clicked-add-instagram-personal";
export const ADD_ACCOUNT_CLICKED_FACEBOOK = "accounts-clicked-add-facebook";
export const ADD_ACCOUNT_CLICKED_LINKEDIN = "accounts-clicked-add-linkedin";
export const ADD_ACCOUNT_CLICKED_LINKEDIN_PERSONAL =
  "accounts-clicked-add-linkedin-personal";
export const ADD_ACCOUNT_CLICKED_GMB = "accounts-clicked-add-gmb";
export const ADD_ACCOUNT_CLICKED_TWITTER = "accounts-clicked-add-twitter";
export const ADD_ACCOUNT_CLICKED_YOUTUBE = "accounts-clicked-add-yt";
export const ADD_ACCOUNT_CLICKED_PINTEREST = "accounts-clicked-add-pi";
export const ADD_ACCOUNT_CLICKED_PINTEREST_V3 = "accounts-clicked-add-pi-v3";
export const ADD_ACCOUNT_CLICKED_TIKTOK = "accounts-clicked-add-tt";
export const ADD_ACCOUNT_CLICKED_THREADS = "accounts-clicked-add-th";
export const ADD_ACCOUNT_CLICKED_THREADS_NOTIFICATION =
  "accounts-clicked-add-th-notification";
export const ADD_ACCOUNT_CLICKED_SNAPCHAT = "accounts-clicked-add-sc";
export const ADD_ACCOUNT_CLICKED_OTHER = "accounts-clicked-add-ot";

// INBOX
export const INBOX_INTERNAL_NOTE = "inbox-internal-note";
export const INBOX_MESSAGE_SENT = "inbox-message-sent";
export const INBOX_QUICK_REPLY = "inbox-quick-reply";
export const INBOX_PROFILE_LINK_CLICK = "inbox-profile-link-click";
export const INBOX_CLOSE_ALL = "inbox-close-all";
export const INBOX_ASSIGN_USER = "inbox-assign-user";
export const INBOX_ACCOUNT_SELECTED = "inbox-account-selected";
export const INBOX_CONVERSATION_STARRED = "inbox-conversation-starred";
export const INBOX_CONVERSATION_REOPENED = "inbox-conversation-reopened";
export const INBOX_CONVERSATION_CLOSE = "inbox-close-conversation";
export const INBOX_VIEW_SELECTED = "inbox-view-selected";
export const INBOX_MENU_CLICKED = "inbox-menu-clicked";
export const INBOX_COPY_CAPTIVATE_REVIEW = "copy-captivate-review";
export const INBOX_TAGGED_IN_CREATE = "inbox-tagged-in-create";
export const INBOX_TAGGED_IN_LIBRARY = "inbox-tagged-in-library";
export const INBOX_CHIPS_SELECTED = "inbox-chips-selected";
export const INBOX_ESCALATION_STARTED = "inbox_escalation_started";
export const INBOX_ESCALATION_COMPLETED = "inbox_escalation_completed";
export const INBOX_ESCALATION_FAILED = "inbox_escalation_failed";

// POST
export const POST_STATUS_FILTER = "post-status-filter";
export const POST_TYPE_FILTER = "post-type-filter";
export const POST_CONTENT_TYPE_FILTER = "post-content-type-filter";
export const COPY_TO_DRAFT_SELECT = "copy_to_draft_select";
export const COPY_TO_DRAFT_ACTION = "copy_to_draft_action";
export const COPY_TO_DRAFT_ADD_ACCOUNT = "copy_to_draft_add_account";
export const POST_DUPLICATE = "post-duplicate";
export const CLICKED_PREVIEW_POST_MODAL = "clicked-preview-post-modal";
export const CREATE_SINGLE_POST = "create-single-post";
export const UNLINK_TOGGLE_TW = "unlink-toggle-tw";
export const CREATE_POST_YT = "create-post-yt";
export const CREATE_POST_LI = "create-post-linkedIn";

// USER PAGE
export const USER_PAGE_NAVIGATION = "user-page-navigation";
export const USER_PAGE_NOTIFICATION_EXPAND_TEXT =
  "user-page-notification-expand-text";
export const USER_PAGE_NOTIFICATION_EXPAND_CARET =
  "user-page-notification-expand-caret";
export const USER_PAGE_NOTIFICATION_HIDE = "user-page-notification-hide";
export const USER_PAGE_NOTIFICATION_HELP = "user-page-notification-help";

// PLANNER
export const PLANNER_QUEUE_MESSAGE_EXPAND = "planner-queue-message-expand";
export const PLANNER_QUEUE_HIDDEN = "planner-queue-hidden";
export const PLANNER_QUEUE_SETUP = "planner-queue-setup";

// NEW CALENDAR
export const NEW_CAL_DELETE_DRAFT = "new_cal_delete_draft";
export const NEW_CAL_DRAG_DRAFTS = "new-cal-drag-drafts";
export const NEW_CAL_WORK_DAY_VIEW = "new_cal_work_day_view";
export const NEW_CAL_ZOOM_IN = "new_cal_zoom_in";
export const NEW_CAL_ZOOM_OUT = "new_cal_zoom_out";
export const NEW_CAL_ZOOM_FILTER_HOVER = "new_cal_zoom_filter_hover";
export const NEW_CAL_DRAFT_EDIT = "new-cal-draft-edit";
export const NEW_CAL_PERIOD_TODAY = "new-cal-period-today";
export const NEW_CAL_PERIOD_CHANGE = "new-cal-period-change";
export const NEW_CAL_SELECTED_POST_STATUS = "new-cal-selected-post-status";
export const NEW_CAL_POST_AGAIN = "new_cal_post_again";
export const NEW_CAL_POST_AGAIN_ACTION = "new_cal_post_again_action";
export const NEW_CAL_POST_DETAILS = "new-cal-post-details";
export const NEW_CAL_POST_EDIT = "new-cal-post-edit";
export const NEW_CAL_POST_TO_DRAFTS = "new-cal-post-to-drafts";
export const NEW_CAL_POST_DELETE = "new-cal-post-delete";
export const NEW_CAL_POST_CREATE = "new-cal-post-create";
export const NEW_CAL_CLICK_POST_STATUS = "new-cal-click-post-status";
export const NEW_CAL_FILTERS_SHOW = "new-cal-filters-show";
export const NEW_CAL_FILTERS_HIDE = "new-cal-filters-hide";
export const NEW_CAL_FILTERS_ACCOUNTS = "new-cal-filters-accounts";
export const NEW_CAL_FILTERS_EVENTS = "new-cal-filters-events";
export const NEW_CAL_DRAFTS_SHOW = "new-cal-drafts-show";
export const NEW_CAL_DRAFTS_HIDE = "new-cal-drafts-hide";
export const CALENDAR_NOTE_DELETED = "calendar_note_deleted";
export const CALENDAR_NOTE_EDITED = "calendar_note_edited";
export const CALENDAR_NOTE_CREATED = "calendar_note_created";
export const ICS_IMPORTED = "ics-imported";

// Media Library
export const SELECTED_MEDIA_FROM_LIBRARY = "selected-media-from-library";
export const CREATE_POST_FROM_LIBRARY_SCREEN =
  "create-post-from-library-screen";
export const FRONTIFY_WIDGET_CLICKED = "frontify-widget-clicked";

// SKED CAPTION
export const SELECTED_ASSET_DESC = "selected-asset-description";
export const HASHTAG_RECOMMENDATION_OPENED = "hashtag-recommendation-opened";
export const HASHTAG_RECOMMENDATION_SELECTED = "recommended-hashtag-selected";

// COLLABORATION
export const COLLABORATION_VIEW_LINKS = "collaboration-view-links";
export const COLLABORATION_CREATE_LINKS = "collaboration-create-link";
export const COLLABORATION_CREATE_EXT_LINK = "create_ext_link";
export const ADD_USER_CLICKED = "add-user-clicked";

export const GROUP_SELECT_POST_CREATE = "group_select_post_create";
export const PHOTO_EDITOR_EXPORT = "image-editor-library-export";
export const VIDEO_EDITOR_EXPORT = "video-editor-library-export";
export const VIEWED_SKED_STORY = "viewed-sked-story";
export const REQUESTED_TO_PAUSE_ACCOUNT = "Requested to pause account";
export const REQUESTED_TO_CANCEL_ACCOUNT = "requested-cancel-account";

// COMMENTS
export const COMMENTS_TAB = "comments-click-tab";

// AI CAPTION
export const CREATE_BUTTON = "Captivate-create";
export const COPY_IDEA = "Captivate-copy-idea";
export const NEW_IDEA = "Captivate-new-idea";
export const UPDATE_TO_CAPTIVATE_CREATE = "Update-to-captivate-create	";
export const UPDATE_TO_CAPTIVATE_COPY_IDEA = "Update to captivate-copy-idea	";

// Insights Add Pdf reports modal

// When a user sees the PDF upsell modal
export const PDF_UPSELL_MODAL = "pdf-upsell-modal";
// When a user downloads a sample PDF report
export const SAMPLE_REPORT_DOWNLOAD = "sample-report-download";
//  When a user clicks the contact us to add PDF reports button:
export const PDF_CONTACT_BUTTON = "pdf-contact-button";

// Setting
export const CANCEL_PLAN_CLICK = "cancellation-click";

// SKED HOME
export const HOME_GROUP_CREATE = "home-group-create";
export const HOME_GROUP_SAVE = "group-save";
export const HOME_ACCOUNTS = "home-accounts";
export const HOME_INSIGHTS_CLICK = "home-insights-click";
export const HOME_INBOX_CLICK = "home-inbox-click";
export const HOME_INBOX_UGC = "home-inbox-ugc";
export const HOME_POSTS = "home-posts";
export const HOME_CAPTIVATES = "home-captivate";
export const ONBOARDING_CONNECT_ACCOUNT_CLICKED =
  "onboarding_connect_account_clicked";
export const ONBOARDING_PLATFORM_BUTTON_CLICKED =
  "onboarding_platform_button_clicked";
export const ONBOARDING_BRAND_KIT_CLICKED = "onboarding_brand_kit_clicked";
export const ONBOARDING_CREATE_IDEA_CLICKED = "onboarding_create_idea_clicked";
export const ONBOARDING_CREATE_POST_CLICKED = "onboarding_create_post_clicked";
export const HOME_IDEAS_CTA_CLICKED = "home_ideas_cta_clicked";

export const UPGRADE_LABELS_PLANNING_VIEWED = "Upgrade-labels-planning-viewed";
export const UPGRADE_TEAMWORK_VIEWED = "Upgrade-teamwork-viewed";
export const UPGRADE_APPROVAL_VIEWED = "Upgrade-approval-viewed";
export const UPGRADE_PAID_INSIGHTS_VIEWED = "Upgrade-paid-insights-viewed";

export const UPGRADE_PDF_REPORT_VIEWED = "Upgrade-pdf-report-viewed";
export const UPGRADE_COMPETITOR_VIEWED = "Upgrade-competitor-viewed";

export const UPGRADE_EXCEL_REPORTS_VIEWED = "Upgrade-excel-reports-viewed";
export const UPGRADE_COMPARISON_VIEWED = "Upgrade-comparison-viewed";
export const UPGRADE_LABELS_REPORTING = "Upgrade-labels-reporting";
export const UPGRADE_LIBRARY_VIEWED = "Upgrade-library-viewed";
export const UPGRADE_USERS_VIEWED = "Upgrade-users-viewed";
export const UPGRADE_ESSENTIALS_VIEWED = "Upgrade-essentials-viewed";
export const UPGRADE_FRONTIFY_VIEWED = "Upgrade-frontify-viewed";
export const UPGRADE_REPORT_BUILDER_VIEWED = "Upgrade-report-builder-viewed";
export const UPGRADE_CONTENT_COLLECT_VIEWED = "Upgrade-content-collect-viewed";
export const CONTENT_COLLECT_UPSELL_CTA_CLICKED =
  "content-collect-upsell-cta-clicked";
export const CONTENT_COLLECT_FEEDBACK_CLICKED =
  "content-collect-feedback-clicked";

// Content Collect dashboard events, `content-collect-<object>-<action>` with
// snake_case props. The one guest-side event is sent by sked-api when a
// submission is finalised, not from the browser.
export const CONTENT_COLLECT_LIST_VIEWED = "content-collect-list-viewed";
export const CONTENT_COLLECT_BUILDER_VIEWED = "content-collect-builder-viewed";
export const CONTENT_COLLECT_DETAIL_VIEWED = "content-collect-detail-viewed";
export const CONTENT_COLLECT_GUIDED_UPGRADE_VIEWED =
  "content-collect-guided-upgrade-viewed";
export const CONTENT_COLLECT_CREATED = "content-collect-created";
export const CONTENT_COLLECT_UPDATED = "content-collect-updated";
export const CONTENT_COLLECT_SAVE_FAILED = "content-collect-save-failed";
export const CONTENT_COLLECT_ACTIVATED = "content-collect-activated";
export const CONTENT_COLLECT_LIFECYCLE_CHANGED =
  "content-collect-lifecycle-changed";
export const CONTENT_COLLECT_DUPLICATED = "content-collect-duplicated";
export const CONTENT_COLLECT_LINK_COPIED = "content-collect-link-copied";
export const CONTENT_COLLECT_QR_DOWNLOADED = "content-collect-qr-downloaded";
export const CONTENT_COLLECT_SUBMISSIONS_EXPORTED =
  "content-collect-submissions-exported";
export const CONTENT_COLLECT_FILES_EXPORT_REQUESTED =
  "content-collect-files-export-requested";

export const CREATE_POST_LINKEDIN_PDF = "create-post-linkedin-pdf";
export const COVER_IMAGE_SELECTED = "cover-image-selected";
export const CONTACT_SUPPORT_CONNECTING_ACCOUNT =
  "Contact-Support-Connecting-Account";

export const SELECTED_MEDIA_FROM_LIBRARY_BULK =
  "selected-media-from-library-bulk";
export const CREATE_POST_BULK_ADD = "create-post-bulk-add";
export const CREATE_POST_BULK_CANCEL = "create-post-bulk-cancel";
export const CREATE_POST_SINGLE_CANCEL = "create-post-single-cancel";
export const CREATE_POST_BULK_DUPLICATE = "create-post-bulk-duplicate";
export const EDIT_POST = "edit-post";
export const EDIT_POST_OPEN = "edit-post-open";
export const EDIT_POST_MISSING_IDENTIFIER = "edit-post-missing-identifier";

export const META_POST_BOOST_CLICK = "meta-post-boost-click";
export const META_POST_ELIGIBLE_CHECK = "meta-post-eligible-check";
export const META_POST_BOOST_SUBMIT = "meta-post-boost-submit";
export const META_POST_BOOST_ACCOUNT_LINK = "meta-post-boost-account-link";

// UNSAVED POST RESTORATION
export const UNSAVED_POST_RESTORE_DIALOG_SHOWN =
  "unsaved-post-restore-dialog-shown";
export const UNSAVED_POST_RESTORE_ACTION = "unsaved-post-restore-action";

// FACEBOOK STORY PROMO
export const FB_STORY_PROMO_SHOWN = "fb-story-promo-shown";
export const FB_STORY_PROMO_CTA_CLICK = "fb-story-promo-cta-click";
export const FB_STORY_PROMO_DISMISS = "fb-story-promo-dismiss";
